import React from "react";
import { Route, Routes } from "react-router-dom";

import { useNewBreadcrumb } from "recoils";

import { SETTINGS_ROUTER } from "./consts";
import {
  USER_CONSENT_MANAGAMENT_PAGE,
  USER_PREFERENCE_PAGE,
  UserPreferencePage,
} from "./user-preference";
import { ConsentManagament } from "./user-preference/consentmanagament";


export const SettingsRouterV2 = () => {
  useNewBreadcrumb(SETTINGS_ROUTER.TITLE);

  return (
    <Routes>
      <Route
        path="/"
        element={<UserPreferencePage />}
      >
        <Route
          path={USER_PREFERENCE_PAGE.PATH}
          element={<UserPreferencePage />}
        />
        <Route
          path={USER_CONSENT_MANAGAMENT_PAGE.PATH}
          element={<ConsentManagament />}
        />
      </Route>
    </Routes>
  );
};
